import FeeMonthProjection from "./FeeMonthProjection";
import "./PaymentHistoryView.css";

export default function PaymentHistoryView({
  groups = [],
  totals,
  onBack,
}) {
  return (
    <div className="payment-history-view">
      <header className="payment-history-view__header">
        <button
          type="button"
          className="payment-history-view__back"
          onClick={onBack}
        >
          ← Back to My Courses
        </button>
        <p className="payment-history-view__eyebrow">Fees</p>
        <h1 className="payment-history-view__title">Payment history</h1>
      </header>

      <section
        className="payment-history-view__panel"
        aria-label="Payment history details"
      >
        {groups.length ? (
          <FeeMonthProjection groups={groups} totals={totals} hideHead />
        ) : (
          <p className="payment-history-view__empty">
            No fee periods are available for this registration yet.
          </p>
        )}
      </section>
    </div>
  );
}
